const formatPrice = (value, currency = "") => {
  const number = Number(value || 0);

  return `${number.toLocaleString("lt-LT", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${currency}`;
};

export default formatPrice;